<template>
  <p class="mb-1 font-medium">
    <slot></slot>
  </p>
</template>
